import { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

import { usePageSpaceKey } from '@confluence/page-context';
import { useRouteActions } from '@confluence/route-manager/entry-points/RouteState.ts';
import { useSpaceEnabledContentTypes } from '@confluence/create-blank-fabric-page/entry-points/useSpaceEnabledContentTypes.ts';
import { ConfluencePageSubType } from '@confluence/create-blank-fabric-page/entry-points/CreateBlankPageMutation.ts';
import { buildCreationLink } from '@confluence/create-blank-fabric-page/entry-points/createContentRouteUtils.ts';

export const useCreateDoc = (): {
	createDoc: () => void;
} => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { push } = useRouteActions();
	const [spaceKey] = usePageSpaceKey();
	const { isCreateLiveDocEnabled } = useSpaceEnabledContentTypes(spaceKey);

	const createDoc = useCallback((): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'createDoc',
				source: 'popularFeedEmptyState',
				attributes: {
					contentType: isCreateLiveDocEnabled ? 'liveDoc' : 'page',
					hasSpaceContext: !!spaceKey,
				},
			},
		}).fire();

		const createUrl = buildCreationLink({
			contentType: 'page',
			subType: isCreateLiveDocEnabled ? ConfluencePageSubType.LIVE : undefined,
			spaceKey,
			withFallback: true,
			source: 'popularFeedEmptyState',
		});

		push(createUrl);
	}, [createAnalyticsEvent, push, isCreateLiveDocEnabled, spaceKey]);

	return { createDoc };
};
